module.exports = __webpack_public_path__ + "static/img_2.c6720da6.jpg";